export const elevation = {
    floor01: 1,
    floor02: 2,
    floor03: 3,
    floor04: 4,
    floor100: 100,
};
export default elevation;
